module.exports = __webpack_public_path__ + "img/rating-page-slider-desktop-4.2455f2ce.png";